import { amplitudeEvent } from 'lib/amplitude'
import { trackVirtualCoachingEvent } from 'pages/pga-coach/virtual-coaching/analytics'

// Golfer-side events. Names follow the coach side's `VIRTUAL_COACHING_EVENTS`.
export const VIRTUAL_COACHING_STUDENT_EVENTS = {
  UPLOAD_VIEWED: 'virtual-coaching-upload-viewed',
  VIDEO_SELECTED: 'virtual-coaching-video-selected',
  VIDEO_UPLOAD_FAILED: 'virtual-coaching-video-upload-failed',
  VIDEOS_SUBMITTED: 'virtual-coaching-videos-submitted',
  VIDEOS_SUBMIT_FAILED: 'virtual-coaching-videos-submit-failed',
  REQUEST_VIEWED: 'virtual-coaching-student-request-viewed',
}

export const PURCHASE_TYPE = 'virtual_coaching'

export const trackVirtualCoachingCheckoutViewed = () =>
  amplitudeEvent('view-checkout-screen', {
    payment_required: true,
    purchase_type: PURCHASE_TYPE,
    payment_intent_enabled: true,
  })

export const trackVirtualCoachingPurchaseComplete = () =>
  amplitudeEvent('complete-checkout', { purchase_type: PURCHASE_TYPE })

export const trackVirtualCoachingStudentEvent = trackVirtualCoachingEvent
